<template>
  <ul class="language-switch">
    <li v-for="lang in i18n" :class="{'active': lang.active}">
      <a @click="setLanguage(lang.key)">{{lang.display}}</a>
    </li>
  </ul>
</template>
<script>
  const rclass = /[\t\r\n]/g;
  const storeKey = 'EVERONET_LOCALE';
  const defaultLanguage = 'en';
  export default {
    name: 'LanguageSwitch',
    data() {
      return {
        i18n: [{
          key: 'en',
          display: 'En',
        },
        {
          key: 'jp',
          display: 'Jp',
        },
        ],
        langKey: defaultLanguage,
      };
    },
    created() {
      // 先从本地存储读取language值，
      let langKey = this.getStoredLanguage();
      if (langKey === '') {
        // 如果读取到空字符串，从浏览器中读取language值
        langKey = this.getLanguageFromBrowser();
      }

      this.i18n = this.i18n.map(item => {
        if (item.key === langKey) {
          item.active = true;
        }
        return item;
      })
      this.langKey = langKey;

      // 监听初始化语言事件
      this.$translate.$on('language:init', language => {
        this.languageClass(language);
      });

      // 监听切换语言事件
      this.$translate.$on('language:changed', language => {
        for (const item of this.i18n) {
          if (item.key === language) {
            this.$set(item, 'active', true);
          } else {
            this.$set(item, 'active', false);
          }
        }

        this.languageClass(language);
      });
    },
    mounted() {
      this.$translate.setLang(this.langKey);
    },
    methods: {
      // 日语界面下，给body添加 japanese的样式
      languageClass(language) {
        const body = document.querySelector('body');
        if (language === 'jp') {
          this.addClass(body, 'japanese');
        } else {
          this.removeClass(body, 'japanese');
        }
      },
      setLanguage(key) {
        this.$translate.setLang(key);
        this.setStoredLanguage(key);
        for (const item of this.i18n) {
          if (item.key === key) {
            this.$set(item, 'active', true);
          } else {
            this.$set(item, 'active', false);
          }
        }
      },
      getStoredLanguage() {
        const lang = localStorage.getItem(storeKey);
        if (typeof lang === 'string') {
          return lang;
        }
        return '';
      },
      setStoredLanguage(key) {
        localStorage.setItem(storeKey, key);
      },
      getLanguageFromBrowser() {
        const language = navigator.browserLanguage ? navigator.browserLanguage : navigator.language;
        if (language.toLowerCase().indexOf('ja') > -1) {
          return 'jp';
        }
        return defaultLanguage;
      },
      addClass(ele, clazz) {
        if (this.hasClass(ele, clazz)) {
          return;
        }

        let cur = ele.nodeType === 1 && (ele.className ? ` ${ele.className} `.replace(rclass, ' ') : ' ');
        cur += `${clazz} `;
        ele.className = cur.trim();
      },
      removeClass(ele, clazz) {
        if (!this.hasClass(ele, clazz)) {
          return;
        }

        let cur = ele.nodeType === 1 && (ele.className ? ` ${ele.className} `.replace(rclass, ' ') : ' ');
        cur = cur.replace(` ${clazz} `, '');
        ele.className = cur.trim();
      },
      hasClass(ele, clazz) {
        const className = ` ${clazz} `;
        if (ele.nodeType === 1 && (` ${ele.className} `).replace(rclass, '').indexOf(className) >= 0) {
          return true;
        }

        return false;
      },
    },
  };

</script>
<style>
  html {
    width: auto;
  }
  
  ul.language-switch {
    float: left;
    margin: 0;
    padding-left: 0;
    list-style: none;
  }
  
  ul.language-switch>li {
    position: relative;
    display: block;
    float: left;
  }
  
  ul.language-switch>li>a {
    text-decoration: none;
    position: relative;
    display: block;
    padding-top: 10px;
    padding-bottom: 10px;
    line-height: 14px;
    width: 34px;
    text-align: center;
    color: #A5DBF7;
    cursor: pointer;
  }
  
  ul.language-switch>li.active>a {
    background-color: #FFF;
    color: #248ACF;
    border-radius: 50%;
  }
  
  ul.language-switch.inverse>li {
    list-style: none;
    float: left;
    margin-left: 8px;
  }
  
  ul.language-switch.inverse>li>a {
    text-decoration: none;
    background: #898c8f;
    color: #FFF;
    border: 2px solid #898c8f;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    line-height: 18px;
    text-align: center;
    cursor: pointer;
  }
  
  ul.language-switch.inverse>li.active>a {
    color: #898c8f;
    background: #FFF;
  }
</style>


// WEBPACK FOOTER //
// LanguageSwitch.vue?7d95f331